import { z } from "zod";

// clean input and then check if it's valid
export const nonEmptyString = (errmsg: string) =>
  z.string().trim().min(1, errmsg);
